import React, { Fragment, useEffect, useState } from "react";
import classNames from "classnames";

import Logo from "~/assets/images/login/login-logo.svg";
import { ReactComponent as Completed }  from "~/assets/images/checkin/completed.svg";

import Confetti from './Confetti';
import { X, XCircle } from "react-feather";


const Claimed = ({message, isError, overlayOpen, setOverlayOpen})=> {

  const [popConfetti, setPopConfetti] = useState(false);

  useEffect(()=> {
    setTimeout(()=> setPopConfetti(overlayOpen), 700);
  }, [overlayOpen]);

  return (
    <Fragment>
      <div className={classNames("daily-checkin-claimed-overlay", {error: isError, success: !isError})}>

        <div> <img src={Logo}/> </div>
        {isError ?
        <XCircle className="text-danger" style={{width: 50, height: 50}} /> :
        <Completed />
        }

        { !isError && <h5> Congratulations </h5> }
        <p> { isError ? message.error || message.token || message.generalError || "" : message } </p>

        <button className="close-btn" onClick={()=> setOverlayOpen(false)}>Close</button>

        { !isError && <Confetti papers={75} trigger={popConfetti} /> }
      </div>
    </Fragment>
  );
};

export default Claimed;
